

// UNA Profile 
// =============
export const PROFILE_URL = '/api/hcp/profile'


// UNA Test 
// =============
// Tests 
export const TESTS_URL = '/api/hcp/tests/'
// Skills Checklists 
export const CHECKLIST_URL = '/api/hcp/checklists/'
// Mandatories 
export const COURSES_URL = '/api/hcp/courses/'


// UNA Wallet 
// =============
export const CREDENTIAL_WALLET_URL = '/api/hcp/credentials/'

// Specialties 
export const SPECIALTIES_URL = '/api/hcp/specialties/'
export const ALL_SPECIALTY_URL = '/api/hcp/data/specialties/'

// Work Experience 
export const WORK_EXPERIENCE_URL = '/api/hcp/work_experiences/'

// Education
export const EDUCATION_URL = '/api/hcp/educations/'

// Licenses 
export const LICENSES_URL = '/api/hcp/licenses/'

// Certifications 
export const CERTIFICATIONS_URL = '/api/hcp/certifications/'

export const CERTIFICATION_SUGGESTIONS='/api/hcp/data/certifications'

// References  
export const REFERENCES_URL = '/api/hcp/references/'

// References  
export const DOCUMENTS_URL = '/api/hcp/documents/'
//carousel
export const carousel = '/api/hcp/images/'









